<template>
  <div class="page-not-found"></div>
</template>

<script>
export default {
  name: "PageNotFound",
  created() {
    this.$message.warning("Page not found... You will be redirected to the main page.");
    setTimeout(() => {
      this.$router.push('/index');
    }, 3000);
  }
}
</script>

<style scoped>
.page-not-found{
  background: url("../../assets/images/error-bg.png") no-repeat center;
  height: 100%;
  width: 100%;
  background-size: cover;
  overflow: hidden;
  position: fixed;
}
</style>